// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mandatory-step_wrapper__vnHWN {
  padding: 24px;
  display: grid;
  grid-template-rows: min-content 1fr min-content;
  gap: 24px;
  border-radius: 6px;
  background-color: var(--primary-background-color);
}

.mandatory-step_header__Ifik0 {
  display: grid;
  grid-template-rows: repeat(3, min-content);
  gap: 12px;
}

.mandatory-step_step__fx5dE {
  font-size: 20px;
  font-weight: 800;
  display: flex;
  justify-content: center;
}

.mandatory-step_illustration__6Q25b {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  & img {
    max-width: 250px;
  }
}

.mandatory-step_primary-wrapper__6sSmN {
  background-color: var(--primary-text-color);
  color: var(--white-text-color);
}

.mandatory-step_primary-text__Fb4CJ {
  color: var(--white-text-color);
}

.mandatory-step_primary-button__MeP09 {
  background-color: var(--white-text-color);
  color: var(--primary-text-color);
}

@media (max-width: 768px) {
  .mandatory-step_wrapper__vnHWN {
    grid-template-rows: repeat(2, min-content);
    height: fit-content;
  }
}

@media (max-width: 768px) {
  .mandatory-step_illustration__6Q25b {
    & img {
      max-width: 100px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/empty-state/steps/mandatory-step.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;;EAEX;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE;IACE,0CAA0C;IAC1C,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE;MACE,gBAAgB;IAClB;EACF;AACF","sourcesContent":[".wrapper {\n  padding: 24px;\n  display: grid;\n  grid-template-rows: min-content 1fr min-content;\n  gap: 24px;\n  border-radius: 6px;\n  background-color: var(--primary-background-color);\n}\n\n.header {\n  display: grid;\n  grid-template-rows: repeat(3, min-content);\n  gap: 12px;\n}\n\n.step {\n  font-size: 20px;\n  font-weight: 800;\n  display: flex;\n  justify-content: center;\n}\n\n.illustration {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n\n  & img {\n    max-width: 250px;\n  }\n}\n\n.primary-wrapper {\n  background-color: var(--primary-text-color);\n  color: var(--white-text-color);\n}\n\n.primary-text {\n  color: var(--white-text-color);\n}\n\n.primary-button {\n  background-color: var(--white-text-color);\n  color: var(--primary-text-color);\n}\n\n@media (max-width: 768px) {\n  .wrapper {\n    grid-template-rows: repeat(2, min-content);\n    height: fit-content;\n  }\n}\n\n@media (max-width: 768px) {\n  .illustration {\n    & img {\n      max-width: 100px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `mandatory-step_wrapper__vnHWN`,
	"header": `mandatory-step_header__Ifik0`,
	"step": `mandatory-step_step__fx5dE`,
	"illustration": `mandatory-step_illustration__6Q25b`,
	"primary-wrapper": `mandatory-step_primary-wrapper__6sSmN`,
	"primary-text": `mandatory-step_primary-text__Fb4CJ`,
	"primary-button": `mandatory-step_primary-button__MeP09`
};
export default ___CSS_LOADER_EXPORT___;
